var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { tabs: "", dark: "" } },
            [
              _c(
                "v-tabs",
                {
                  attrs: {
                    "align-with-title": "",
                    "fixed-tabs": "",
                    centered: "",
                    "icons-and-text": "",
                    color: "transparent"
                  },
                  model: {
                    value: _vm.tabs,
                    callback: function($$v) {
                      _vm.tabs = $$v
                    },
                    expression: "tabs"
                  }
                },
                [
                  _c("v-tabs-slider"),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    { key: "settings" },
                    [
                      _vm._v("\n          Select data\n          "),
                      _c("v-icon", [_vm._v("settings")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    { key: "preview", attrs: { disabled: true } },
                    [
                      _vm._v("\n          Preview data\n          "),
                      _c("v-icon", [_vm._v("find_in_page")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.tabs,
                callback: function($$v) {
                  _vm.tabs = $$v
                },
                expression: "tabs"
              }
            },
            [
              _c(
                "v-tab-item",
                { key: "settings" },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("v-subheader", [_vm._v("Select Years")]),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              staticClass:
                                "v-datatable v-table theme--light v-list--dense",
                              attrs: { id: "download_years" }
                            },
                            [
                              _c("tbody", [
                                _c("tr", [
                                  _c(
                                    "td",
                                    [
                                      _vm._v(
                                        "\n                    Start Year\n                    "
                                      ),
                                      _c(
                                        "v-menu",
                                        {
                                          staticClass:
                                            "scroll-y overflow-y-auto",
                                          attrs: {
                                            origin: "center center",
                                            transition: "scale-transition",
                                            bottom: "",
                                            "offset-y": "",
                                            "max-height":
                                              _vm.downloadSelectsHeight
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var menu = ref.on
                                                return [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        disabled:
                                                          _vm.selectedYear
                                                            .alert === false
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var tooltip =
                                                                ref.on
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      _vm._g(
                                                                        {},
                                                                        menu
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedYearSpan
                                                                                  .start
                                                                                  .year
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _vm.selectedYear.alert
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    dark: "",
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "warning"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .selectedYear
                                                                      .message
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            { attrs: { dense: "" } },
                                            _vm._l(_vm.years, function(
                                              y,
                                              yindex
                                            ) {
                                              return _c(
                                                "v-tooltip",
                                                {
                                                  key: yindex,
                                                  attrs: {
                                                    right: "",
                                                    disabled: y.alert === false
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-list-tile",
                                                    {
                                                      staticClass:
                                                        "year-container",
                                                      attrs: {
                                                        slot: "activator"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.switchStartYear(
                                                            y
                                                          )
                                                        }
                                                      },
                                                      slot: "activator"
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile-title",
                                                        { staticClass: "year" },
                                                        [
                                                          _vm._v(
                                                            "\n                              " +
                                                              _vm._s(y.year) +
                                                              "\n                            "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  y.alert
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                dark: "",
                                                                small: ""
                                                              }
                                                            },
                                                            [_vm._v("warning")]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                y.message
                                                              ) +
                                                              "\n                          "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm._v(
                                        "\n                    End Year\n                    "
                                      ),
                                      _c(
                                        "v-menu",
                                        {
                                          staticClass:
                                            "scroll-y overflow-y-auto",
                                          attrs: {
                                            origin: "center center",
                                            transition: "scale-transition",
                                            bottom: "",
                                            "offset-y": "",
                                            "max-height":
                                              _vm.downloadSelectsHeight
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var menu = ref.on
                                                return [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        disabled:
                                                          _vm.selectedYear
                                                            .alert === false
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var tooltip =
                                                                ref.on
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      _vm._g(
                                                                        {},
                                                                        menu
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedYearSpan
                                                                                  .end
                                                                                  .year
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _vm.selectedYear.alert
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    dark: "",
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "warning"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .selectedYear
                                                                      .message
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            { attrs: { dense: "" } },
                                            _vm._l(_vm.years, function(
                                              y,
                                              yindex
                                            ) {
                                              return !_vm.disableEndYear(y.year)
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      key: yindex,
                                                      attrs: {
                                                        right: "",
                                                        disabled:
                                                          y.alert === false
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          staticClass:
                                                            "year-container",
                                                          attrs: {
                                                            slot: "activator"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.switchEndYear(
                                                                y
                                                              )
                                                            }
                                                          },
                                                          slot: "activator"
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            {
                                                              staticClass:
                                                                "year"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    y.year
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      y.alert
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    dark: "",
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "warning"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    y.message
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-subheader", [_vm._v("Select Indicators")]),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              staticClass:
                                "v-datatable v-table theme--light v-list--dense",
                              attrs: { id: "indicator-selection" }
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "column text-xs-left secondary",
                                        attrs: {
                                          role: "columnheader",
                                          scope: "col"
                                        }
                                      },
                                      [_vm._v("Indicator")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.normalizations, function(n) {
                                      return _c(
                                        "th",
                                        {
                                          key: "add_to_download_" + n.id,
                                          staticClass:
                                            "column text-xs-left secondary",
                                          attrs: {
                                            role: "columnheader",
                                            scope: "col"
                                          }
                                        },
                                        [
                                          n.id === _vm.noNormalization.id
                                            ? _c("span", [
                                                _vm._v(
                                                  "Add non-normalized data"
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "Add data normalized by " +
                                                    _vm._s(
                                                      n.value.toLowerCase()
                                                    )
                                                )
                                              ])
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.indicatorListBasic, function(
                                  i,
                                  index
                                ) {
                                  return _c(
                                    "tr",
                                    { key: "download_tr" + index },
                                    [
                                      i.hasOwnProperty("text")
                                        ? _c("td", [_vm._v(_vm._s(i.text))])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(_vm.normalizations, function(n) {
                                        return i.hasOwnProperty("text")
                                          ? _c(
                                              "td",
                                              { key: _vm.downloadKey(i, n) },
                                              [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    "input-value":
                                                      _vm.indicatorsToDownload[
                                                        _vm.downloadKey(i, n)
                                                      ],
                                                    disabled: !i.norm_by.find(
                                                      function(d) {
                                                        return d.id === n.id
                                                      }
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.toggleDownloadItem({
                                                        indicator: i,
                                                        normalization: n,
                                                        downloadKey: _vm.downloadKey(
                                                          i,
                                                          n
                                                        )
                                                      })
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }),
                                      _vm._v(" "),
                                      !i.hasOwnProperty("text")
                                        ? _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "text-transform": "capitalize"
                                              },
                                              attrs: {
                                                colspan:
                                                  _vm.normalizations.length + 1
                                              }
                                            },
                                            [
                                              _c(
                                                "v-subheader",
                                                { attrs: { inset: "" } },
                                                [_vm._v(_vm._s(i.header))]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { key: "preview" },
                [
                  false
                    ? _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.cData.headers,
                          items: _vm.cData.items,
                          pagination: _vm.pagination
                        },
                        on: {
                          "update:pagination": function($event) {
                            _vm.pagination = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "items",
                              fn: function(props) {
                                return _vm._l(_vm.cData.headers, function(
                                  header
                                ) {
                                  return _c(
                                    "td",
                                    {
                                      key: header.value,
                                      on: {
                                        click: function($event) {
                                          return _vm.clickItem(props.item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(props.item[header.value]) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                })
                              }
                            }
                          ],
                          null,
                          false,
                          3297663154
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "flat" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { target: "_blank" },
                      on: {
                        click: function($event) {
                          _vm.downloadData(_vm.getData(false))
                        }
                      }
                    },
                    [_vm._v("Download CSV-File")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddfd7bc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddfd7bc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadDialog.vue
// module id = null
// module chunks = 